import { useEffect, useMemo, useState } from "react";
import { exceptionResolutionTypes } from "../../../helpers/constants";
import { optionsFromStringList } from "../../../helpers/select";

const BaseResolutionTypeOptions = [
    { label: "Exception", value: exceptionResolutionTypes.Exception },
    { label: "Error", value: exceptionResolutionTypes.Error }
];

const TransactionTypes = {
    "PURCH": [
        { label: "Regular", value: exceptionResolutionTypes.Regular },
        ...BaseResolutionTypeOptions
    ],
    "SALE": [
        { label: "Top-Up Cash", value: exceptionResolutionTypes.TopUpCash },
        ...BaseResolutionTypeOptions
    ]
}

const useBulkResolve = (defaultCustodianCode = "HUBW") => {

    const defaultRequest = {
        maxValue: 0,
        platformTransactionType: Object.keys(TransactionTypes)[0],
        custodianCode: defaultCustodianCode,
        resolutionType: null
    };

    const [request, setRequest] = useState(defaultRequest);

    const updateRequest = (property, value) => setRequest(prev => ({
        ...prev,
        [property]: value
    }));

    const resetRequest = () => setRequest(defaultRequest);

    const transactionTypeOptions = useMemo(() => optionsFromStringList(Object.keys(TransactionTypes)), []);
    const resolutionTypeOptions = useMemo(() => TransactionTypes[request.platformTransactionType], [request.platformTransactionType]);

    const canSubmit = Object.values(request).every(val => val != null);

    useEffect(() => {
        if (!resolutionTypeOptions.map(obj => obj.value).includes(request.resolutionType))
            updateRequest("resolutionType", null)
    }, [request.resolutionType, resolutionTypeOptions])

    return {
        request,
        updateRequest,
        resetRequest,
        custodianOptions: optionsFromStringList(["HUBW", "AJBS"]),
        transactionTypeOptions,
        resolutionTypeOptions,
        canSubmit
    }
}

export default useBulkResolve;